import Guard from '../../services/Middleware'

export default [{
    path: '/Inicio',
    name:'Inicio',
    component: () => import('@/views/home/Index.vue'),
    beforeEnter: Guard.auth
}]